import React from "react";
import axios from 'axios';
//import {Link} from "react-router-dom"
// reactstrap components
import {
  Card,
  CardBody,
  Table,
  Button,
  Badge,
  UncontrolledTooltip
} from "reactstrap";

//import data



class CandidateProfile1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        notedata : [],
        note : ''
    };
  }
  handleMoreClick = () => {
    this.setState({
      buttonToRender: (this.state.buttonToRender + 2)
    });
  };


  componentDidMount(){
  
  }
  componentWillMount(){
    console.log("props",this.props)
    const {job_id} = this.props.match.params;
    console.log(job_id)
    this.setState({job_id})
    const {app_id} = this.props.match.params;
    console.log(app_id)
    this.setState({app_id})
    const user = JSON.parse(localStorage.getItem('user'))
    this.setState({user})
    console.log(user)
    axios.post('/api2/getclosejobnotes',{...this.state,job_id,app_id})
    .then(response => {
      console.log(response)
      const note = response.data[0].note;
      this.setState({ note });
      // localStorage.setItem('hosp', JSON.stringify(this.state.hosp));
      console.log(note);
      const notedata = response.data
      this.setState({ notedata });
      //state : {user : this.state.user}
      
      //this.setState({redirect : true})
    })
    .catch(error => {
      console.log(error.response);

      // const msg = error.response.data.Message;
      // this.setState({msg});
    })
  }
  componentWillUnmount(){
   
  }
  
  submitHandler = () =>{
    console.log(this.state)
    if(this.state.note=== ""){
      const note_err = "Hinweis ist leer"
      this.setState({note_err})
    }else{
      this.setState({note_err:undefined})
      axios
      .post('/api2/addclosejobnote',this.state)
      .then(response =>{
        console.log(response)
        const note_msg = response.data.msg;
        this.setState({note_msg})
        window.location.reload();
        // const WorkExp1 = response.data;
        // this.setState({ WorkExp1 });
      })
      .catch(error =>{
        console.log(error)
      })
    }
  }
  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  deletenoteHandle(noteid){
    console.log("note id",noteid)
    axios
      .post('/api2/delnote2',{...this.state,noteid})
      .then(response =>{
        console.log(response)
        const note_msg = response.data.msg;
        this.setState({note_msg})
        window.location.reload();
        // const WorkExp1 = response.data;
        // this.setState({ WorkExp1 });
      })
      .catch(error =>{
        console.log(error)
      })
  }
  render() {
    
    return (
      <div className="content">
     
         <Badge className="mr-1" color="danger" pill>
                       {this.state.note_err}
                        </Badge><Badge className="mr-1" color="success" pill>
                       {this.state.note_msg}
                        </Badge>
                    <Card>
                <CardBody>
                <Table responsive>
                    <thead>
                      <tr>
                        <th>Admin Id</th>
                        <th>Note Datum</th>
                        <th>Note</th>
                        <th>Löschen</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.notedata.map(user => {
    return (
      <>
                      <tr>
                      <td>{user.admin_email}</td>
                       <td>{user.note_date}</td>
                       <td>{user.note}</td>
                       <td> <Button
                            className="btn-icon"
                            color="danger"
                            id="tooltip3662466421"
                            size="sm"
                            type="button"
                            onClick={this.deletenoteHandle.bind(this, user.note_id)}
                          >
                            <i className="fa fa-trash" />
                          </Button>{" "}
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip3662466421"
                          >
                            Löschen 
                          </UncontrolledTooltip></td>



                      </tr>
                      </>
    );
})}
                    </tbody>
                  </Table>
                  <br></br>
                  <br></br>
                  <center> <textarea
                      rows='6'
                      cols='110'
                      name="note"
                      //value={this.state.note}
                      placeholder="Schreibe hier eine Notiz"
                      onChange={this.changeHandler}
                      /> 
                      <br />
                      {this.state.admin_id}<br />
                      {this.state.note_date}<br></br>
                      <Button color = 'primary'
                      onClick = {this.submitHandler}
                      >Submit</Button></center>
               
                </CardBody>
              </Card>
                 
           
 
      </div>
    );
  }
}

export default CandidateProfile1;
